import React, { useEffect } from "react";
import TopBar from "./topbar";
import NavBar from "./navbar";
import MobileNav from "./mobilenav";
import Logo from "../../assets/img/logo.jpg";
import { Link } from "react-router-dom";
import TopCalendar from "./topcalendar";
const Header = () => {
  const isSticky = () => {
    const header = document.querySelector(".MainHeader");
    const scrollTop = window.scrollY;
    if (header) {
      scrollTop >= 5
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);
  return (
    <header className="MainHeader" role="banner">
      <div className="TopBar">
        <div className="wrapper">
          <div className="TopBarBox">
            <div className="TopLeft">
              <TopCalendar />
            </div>
            <div className="TopRight">
              <TopBar />
            </div>
          </div>
        </div>
      </div>
      <div className="NavBar" role="navigation" aria-label="Main navigation">
        <div className="wrapper">
          <div className="NavBarBox">
            <div className="Logo">
              <Link to="/" aria-label="Go to homepage">
                <img src={Logo} alt="Guheshwori Merchant Banking and Finance Ltd. logo" />
              </Link>
            </div>
            <div className="NavItems">
              <NavBar />
            </div>
            <MobileNav />
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
